import { render, staticRenderFns } from "./tos.vue?vue&type=template&id=0955933a&scoped=true&"
import script from "./tos.vue?vue&type=script&lang=ts&"
export * from "./tos.vue?vue&type=script&lang=ts&"
import style0 from "./tos.vue?vue&type=style&index=0&id=0955933a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0955933a",
  null
  
)

export default component.exports